import { AccountConsumer, AccountContext } from './AccountContext'
import AccountProviderAuth0 from './AccountProviderAuth0'
import { AUTH_TOKEN_KEY } from '../../utils/constants'

export { AUTH_TOKEN_KEY }
export const ONE_MONTH_IN_MS = 30 * 24 * 60 * 60
export const ONE_YEAR_IN_MS = 365 * 24 * 60 * 60

export { AccountContext, AccountConsumer, AccountProviderAuth0 }
